import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PostingsOperations } from '@panel/avisos/ducks/posting';
import { userInfoOperations, userInfoSelectors } from '../state/ducks/user';
import { unifiedPanel } from '../constants/unifiedPanel';
import { detectAppUtils } from '../utils/detectAppUtils';

const useGetUser = () => {
  const [isInstalled, setIsIntalled] = useState(false);
  const userInfo = useSelector(userInfoSelectors.getuserInfoState);
  const dispatch = useDispatch();
  const site = process.env.REACT_APP_BUILD_SITE;
  const is24MX = site.includes('24MX');
  if (is24MX) {
    detectAppUtils(process.env.REACT_APP_UTILS_REPO, setIsIntalled);
  }

  useEffect(() => {
    if (isInstalled) dispatch(PostingsOperations.checkOutdatedCompany(process.env.REACT_APP_USER_INFO_EXTRA_PARAMETER));
  }, [dispatch, isInstalled]);

  useEffect(() => {
    if (!userInfo.fetched) {
      dispatch(userInfoOperations.fetch());
    } else if (unifiedPanel.includes(site) && userInfo.publisherId && parseInt(userInfo.publisherTypeId) !== 1) {
      dispatch(userInfoOperations.maskSeeker());
    } else if (userInfo.email) {
      dispatch(userInfoOperations.notMaskUser());
    }
  }, [
    userInfo.fetched,
    dispatch,
    site,
    userInfo.publisherId,
    userInfo.publisherTypeId,
    userInfo.isLoading,
    userInfo.email,
    isInstalled,
    is24MX
  ]);
};

export { useGetUser };
